import { useContext } from 'react'
import { UpdatesSubscriptionContext } from '../contexts/UpdatesSubscription'

const useUpdatesSubscription = () => {
    const context = useContext(UpdatesSubscriptionContext)

    if (!context) throw new Error('useUpdatesSubscription must be placed within UpdatesSubscriptionsProvider')

    return context
}

export default useUpdatesSubscription
